<div class="copyright-block" *letVar="queryParams$ | async as params">
    <p class="mat-small">&copy;{{ year }} Clare Controls</p>
    <p class="terms mat-small">
        <a rel="noopener noreferrer" target="_blank" href="https://www.clarecontrols.com/home-automation/terms-of-use/">Terms of Use</a>
        <span class="link-divider">&bull;</span>
        <a rel="noopener noreferrer" target="_blank" href="https://www.clarecontrols.com/home-automation/privacy-policy/">Privacy Policy</a>
        <ng-container *ngIf="params?.staff !== 'false'">
            <span class="link-divider">&bull;</span>
            <a rel="noopener noreferrer" target="_blank" href="https://www.clarecontrols.com/contact">Contact Us</a>
        </ng-container>
    </p>
</div>
